<template>
  <div>
    <a-modal :visible="visible" :footer="null" :closable="false" :width="510">
      <div class="contract_show">
        <div class="flex-between contract_top">
          <div>{{ $t('detail.contact_us') }}</div>
          <img src="~/assets/house/close.svg" @click="visible = false" />
        </div>
        <div class="weixin_name">{{ currentCountryInfo.name }}</div>
        <div class="weixin_position">
          {{
            $t('home.footer_Yard_Zeal') +
            ($i18n.locale == 'zh' ? currentCountryInfo.positionNameZh : currentCountryInfo.positionNameEn)
          }}
        </div>
        <img :src="currentCountryInfo.files && currentCountryInfo.files[0].url" width="224" />
        <div class="weixin_text">{{ $t('detail.scan_code') }}</div>
        <div class="weixin_text" style="display: flex; justify-content: center">
          <div>{{ $t('detail.phone_number') }}：</div>
          <div>
            <div v-for="(item, index) in currentCountryInfo.phoneInfoList" :key="index">
              {{ item.areaCode + ' ' + item.phone }}
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    currentCountryInfo() {
      return ((this.$store.state.currentCountryInfo || {}).contactDtoList || [])[0] || {}
    },
  },
  methods: {
    show() {
      this.visible = true
    },
  },
}
</script>
<style lang="less" scoped>
.contract_show {
  width: 100%;
  background-image: url('~assets/house/contract_bg.svg');
  background-repeat: no-repeat;
  padding: 30px;
  color: #fff;
  text-align: center;
  .contract_top {
    font-size: 24px;
    img {
      cursor: pointer;
    }
  }
  .weixin_name {
    margin-top: 60px;
    font-weight: bold;
    color: #ffffff;
    font-size: 28px;
    line-height: 33px;
  }
  .weixin_position {
    font-size: 24px;
    color: rgba(255, 255, 255, 0.85);
    margin-top: 20px;
    margin-bottom: 60px;
  }
  .weixin_text {
    font-size: 24px;
    color: #000000;
    padding: 10px 0;
  }
}
</style>